import React from "react";
import "./assets/css/selectStyle.css";

const Select = (props: any) => {

  let placeholder = props.placeholder || "Select...";

  return (
    <div className="form-group">
      <label
        className={
          props.labelClass === "form__label"
            ? props.labelClass
            : "content__label"
        }
        htmlFor={props.name}
      >
        {" "}
        {props.title}{" "}
      </label>
      <div
        className={
          props.className
            ? `selectContainer ${props.className}`
            : "selectContainer"
        }
      >
        <select
          name={props.name}
          defaultValue={props.defaultValue}
          value={props.value}
          onChange={props.handleChange}
          disabled={props.disabled}
        >
          <option value="" disabled={placeholder ? false : true}>
            {placeholder}
          </option>
        {props.options && props.options.map((option: any) => {
            return (
              <option
                key={option.value}
                value={option.value}
                label={option.label}
              >
                {option.label}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default Select;
